import { useHistory } from 'react-router-dom';
import AppEnvironment from '../../../../../../../components/enums/appEnvironment.enum';
import { ClarityEvents } from '../../../../../../../lib/clarity/types/clarityEvents.types';
import { captureEvent } from '../../../../../../../lib/clarity/utils/captureEvent.utils';
import PATHS from '../../../../../../../routes/routes.const';
import { useAppEnvironmentStore } from '../../../../../../../stores/AppEnvironment/appEnvironment.store';
import { useApplicationContext } from '../../../../../../context/ApplicationContext/ApplicationContext';
import useAppEnvironment from '../../../../../../context/ApplicationContext/hooks/useAppEnvironment/useAppEnvironment';
import { OfflineStatus } from '../../../../../../offline/domain/offlineOrder/offlineOrder.types';
import { useOrderContext } from '../../../../../contexts/Order.context';
import { StatusType } from '../../../../../order.types';
import { OrderView } from '../../../../../ordersView.types';
import { getOrderView } from '../../../../../ordersView.utils';

export const useEditOrderInBrandButton = () => {
  const history = useHistory();
  const { order } = useOrderContext();
  const appEnvironment = useAppEnvironmentStore((state) => state.appEnvironment);
  const { applyBrandEnvironment } = useAppEnvironment();
  const {
    team,
    userRole,
    changeBrand,
    state: { brands },
  } = useApplicationContext();

  const orderBrand = order ? brands.find((item) => item.id === order.brand.id) : undefined;

  const orderViewMockingBrandEnvironment = getOrderView({
    role: userRole,
    appEnvironment: AppEnvironment.BRAND,
    integrations: team?.brand?.integrations,
    orderIntegrationStatus: order?.synchronized,
    orderStatus: order?.status as StatusType | OfflineStatus | undefined,
  });

  const isButtonVisible =
    !!order &&
    !!orderBrand &&
    appEnvironment === AppEnvironment.STORE &&
    orderViewMockingBrandEnvironment === OrderView.EDIT;

  const handleClick = () => {
    if (!order || !orderBrand) {
      return;
    }

    captureEvent(ClarityEvents.CLICKED_EDIT_ORDER_IN_BRAND);
    changeBrand(orderBrand);
    applyBrandEnvironment();
    history.push(`${PATHS.main.orders.path}/${order.id}/${OrderView.EDIT}`);
  };

  return { isButtonVisible, handleClick };
};
